import { render, staticRenderFns } from "./InlineFileUpload.vue?vue&type=template&id=b84051a2&"
import script from "./InlineFileUpload.vue?vue&type=script&lang=js&"
export * from "./InlineFileUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports